module.exports = __webpack_public_path__ + "static/media/BuyNow.e2ba28bf.svg";